import './career.erb';
import './conclusion.erb';
import './course_selection.erb';
import './current_level.erb';
import './education.erb';
import './enem_details.erb';
import './index.erb';
import './index.rb';
import './location.erb';
import './military_exam.erb';
import './oab_phase.erb';
import './oab_redirect.erb';
import './objective.erb';
import './weekly_commitment.erb';
import './welcome.erb';

const SEGMENT_STEPS = {
  concursos: [
    'education',
    'career',
    'location',
    'weekly-commitment',
    'current-level',
    'course-selection',
    'conclusion'
  ],
  oab: [
    'oab-phase',
    'weekly-commitment',
    'current-level',
    'oab-redirect',
    'conclusion'
  ],
  enem: ['enem-details', 'weekly-commitment', 'current-level', 'conclusion'],
  militares: [
    'military-exam',
    'weekly-commitment',
    'current-level',
    'conclusion'
  ]
};

const SEGMENT_PRODUCT_MAP = { concursos: 1, militares: 5, oab: 7, enem: 9 };

const SEGMENT_PRODUCT_LABEL = {
  concursos: 'Concurso Público',
  militares: 'Forças Armadas',
  oab: 'OAB',
  enem: 'Enem e Vestibular'
};

const EDUCATION_LEVELS_WITH_DEGREE = [
  'Cursando Ensino Superior',
  'Ensino Superior Completo',
  'Pós-graduação'
];

const CATEGORY_KEYWORDS = {
  Tribunais: ['TJ', 'TRF', 'TRT', 'TRE', 'Judiciário', 'Justiça'],
  Policial: [
    'Polícia',
    'Policial',
    'PF',
    'PRF',
    'PC',
    'PM',
    'Delegado',
    'Agente'
  ],
  Fiscal: ['Fiscal', 'Receita', 'SEFAZ', 'Auditor', 'ISS'],
  Controle: ['TCU', 'TCE', 'CGU', 'Controle'],
  Bancária: ['Banco', 'Caixa', 'BB', 'Bancário', 'Escriturário'],
  Jurídica: ['Procurador', 'Defensor', 'Promotor', 'MP'],
  Administrativa: ['Administrativo', 'Ministério', 'Prefeitura', 'INSS'],
  'Saúde e Educação': [
    'Enfermeiro',
    'Médico',
    'Professor',
    'EBTT',
    'Saúde',
    'Educação'
  ]
};

const SEARCH_DEBOUNCE_MS = 350;

class SetupWizard {
  constructor() {
    this.$root = $('#js-setup-wizard');

    if (!this.$root.length) {
      return;
    }

    this.products = JSON.parse(this.$root.attr('data-products') || '[]');
    this.userName = this.$root.attr('data-user-name') || '';
    this.bordDomain =
      this.$root.attr('data-bord-domain') || 'app.qconcursos.com';

    this.currentStepIndex = -1;
    this.answers = {
      segment: null,
      educationLevel: null,
      degree: null,
      graduationYear: null,
      careers: [],
      hasOpenNotice: null,
      dedicationTime: null,
      state: null,
      acceptsOtherStates: null,
      barExamPhase: null,
      barExamSubject: null,
      barExamExperience: null,
      enemSubjects: [],
      targetScore: null,
      desiredCourse: null,
      targetUniversity: null,
      militaryExam: null,
      militaryExperience: null,
      studyWeekdays: [],
      dailyHours: null,
      currentLevel: null,
      selectedCourse: null
    };

    this.isSaving = false;
    this.searchDebounceTimer = null;
    this.activeCategory = 'Todos';

    this.bindEvents();
    this.populateGraduationYears();
    this.trackSetupStarted();
  }

  trackSetupStarted() {
    window.UserTracker?.emit('event', {
      eventName: 'account setup started',
      data: {
        request_path: window.location.pathname,
        setup_version: 'setup_v2'
      }
    });
  }

  getSteps() {
    if (!this.answers.segment) {
      return ['objective'];
    }
    return ['objective', ...SEGMENT_STEPS[this.answers.segment]];
  }

  getTotalSteps() {
    return this.getSteps().length;
  }

  getCurrentStepId() {
    if (this.currentStepIndex < 0) {
      return 'welcome';
    }
    const steps = this.getSteps();
    return steps[this.currentStepIndex] || 'welcome';
  }

  showStep(stepId) {
    this.$root.find('[data-step]').addClass('hidden');
    this.$root.find(`[data-step="${stepId}"]`).removeClass('hidden');
    this.updateProgressBar();
    this.updateNextButton(stepId);
  }

  updateProgressBar() {
    const $progress = $('#wizard-progress');
    const stepId = this.getCurrentStepId();

    if (this.currentStepIndex < 0 || stepId === 'conclusion') {
      $progress.addClass('hidden');
      return;
    }

    $progress.removeClass('hidden');
    const total = this.getTotalSteps();
    const current = this.currentStepIndex + 1;

    const $bar = this.$root
      .find('.progress-bar, [class*="progress-bar"]')
      .first();
    const $text = $('#wizard-progress-text');

    $bar.html(
      Array.from(
        { length: total },
        (_, i) =>
          `<div style="height:6px;flex:1;border-radius:9999px;transition:background 0.3s;background:${i < current ? '#ff5a1f' : '#e5e7eb'}"></div>`
      ).join('')
    );

    $text.text(`${current} de ${total}`);
  }

  updateNextButton(stepId) {
    const $section = $(`[data-step="${stepId}"]`);
    const $btn = $section.find('.wizard-btn-next');

    switch (stepId) {
      case 'objective':
        $btn.prop('disabled', !this.answers.segment);
        break;
      case 'education':
        $btn.prop('disabled', !this.isEducationValid());
        break;
      case 'career':
        $btn.prop('disabled', this.answers.careers.length === 0);
        break;
      case 'location':
        $btn.prop('disabled', !this.answers.state);
        break;
      case 'weekly-commitment':
        $btn.prop(
          'disabled',
          !this.answers.dedicationTime ||
            this.answers.studyWeekdays.length === 0 ||
            !this.answers.dailyHours
        );
        break;
      case 'current-level':
        $btn.prop('disabled', !this.answers.currentLevel);
        break;
      case 'oab-phase':
        $btn.prop('disabled', !this.isOabPhaseValid());
        break;
      case 'enem-details':
        $btn.prop('disabled', this.answers.enemSubjects.length === 0);
        break;
      case 'military-exam':
        $btn.prop('disabled', !this.answers.militaryExam);
        break;
      default:
        break;
    }
  }

  isEducationValid() {
    if (!this.answers.educationLevel) {
      return false;
    }

    if (EDUCATION_LEVELS_WITH_DEGREE.includes(this.answers.educationLevel)) {
      if (!this.answers.degree) {
        return false;
      }

      if (
        this.answers.educationLevel === 'Cursando Ensino Superior' &&
        !this.answers.graduationYear
      ) {
        return false;
      }
    }

    return true;
  }

  isOabPhaseValid() {
    if (!this.answers.barExamPhase || !this.answers.barExamExperience) {
      return false;
    }

    if (
      this.answers.barExamPhase === '2a_fase' &&
      !this.answers.barExamSubject
    ) {
      return false;
    }
    return true;
  }

  goNext() {
    const steps = this.getSteps();
    const maxIndex = steps.length - 1;

    if (this.currentStepIndex < maxIndex) {
      this.currentStepIndex++;
      const stepId = this.getCurrentStepId();
      this.showStep(stepId);

      if (stepId === 'course-selection') {
        this.loadCourses();
      }
    }
  }

  goPrev() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
      this.showStep(this.getCurrentStepId());
    }
  }

  startWizard() {
    this.currentStepIndex = 0;
    this.showStep('objective');
  }

  populateGraduationYears() {
    const currentYear = new Date().getFullYear();
    const $container = $('#education-year-chips');
    const years = [];

    for (let i = 0; i <= 3; i++) {
      years.push(currentYear + i);
    }
    const lastLabel = `${currentYear + 4} ou depois`;

    let html = years
      .map(
        y =>
          `<button type="button" class="wizard-chip" data-select-field="graduationYear" data-select-value="${y}">${y}</button>`
      )
      .join('');
    html += `<button type="button" class="wizard-chip" data-select-field="graduationYear" data-select-value="${lastLabel}">${lastLabel}</button>`;

    $container.html(html);
  }

  handleEducationLevelChange(level) {
    this.answers.educationLevel = level;
    const showDegree = EDUCATION_LEVELS_WITH_DEGREE.includes(level);
    const showYear = level === 'Cursando Ensino Superior';

    if (!showDegree) {
      this.answers.degree = null;
      this.answers.graduationYear = null;
      $('[data-step="education"] [data-select-field="degree"]').removeClass(
        'selected'
      );
      $(
        '[data-step="education"] [data-select-field="graduationYear"]'
      ).removeClass('selected');
    }

    if (!showYear) {
      this.answers.graduationYear = null;
      $(
        '[data-step="education"] [data-select-field="graduationYear"]'
      ).removeClass('selected');
    }

    $('#education-degree-section').toggleClass('hidden', !showDegree);
    $('#education-year-section').toggleClass('hidden', !showYear);
    this.updateNextButton('education');
  }

  handleOabPhaseChange(phase) {
    this.answers.barExamPhase = phase;
    const show2ndPhase = phase === '2a_fase';

    if (!show2ndPhase) {
      this.answers.barExamSubject = null;
      $(
        '[data-step="oab-phase"] [data-select-field="barExamSubject"]'
      ).removeClass('selected');
    }

    $('#oab-subject-section').toggleClass('hidden', !show2ndPhase);
    this.updateNextButton('oab-phase');
  }

  handleCareerToggle($card, value) {
    if (value === 'outro') {
      this.answers.careers = ['outro'];
      this.$root.find('[data-career-value]').removeClass('selected');
      $card.addClass('selected');
    } else {
      const outroIdx = this.answers.careers.indexOf('outro');

      if (outroIdx >= 0) {
        this.answers.careers.splice(outroIdx, 1);
        this.$root.find('[data-career-value="outro"]').removeClass('selected');
      }

      const idx = this.answers.careers.indexOf(value);

      if (idx >= 0) {
        this.answers.careers.splice(idx, 1);
        $card.removeClass('selected');
      } else {
        this.answers.careers.push(value);
        $card.addClass('selected');
      }
    }

    this.updateNextButton('career');
  }

  updateWeeklySummary() {
    const $summary = $('#weekly-summary');
    const days = this.answers.studyWeekdays.length;
    const hours = this.answers.dailyHours;

    if (days > 0 && hours) {
      const dayLabel = days === 1 ? '1 dia/semana' : `${days} dias/semana`;
      $summary.text(`${dayLabel} • ${hours}/dia`).removeClass('hidden');
    } else {
      $summary.addClass('hidden');
    }
  }

  bindEvents() {
    this.$root.on('click', '[data-action="start-wizard"]', e => {
      e.preventDefault();
      this.startWizard();
    });

    this.$root.on('click', '[data-action="next"]', e => {
      e.preventDefault();
      this.goNext();
    });

    this.$root.on('click', '[data-action="prev"]', e => {
      e.preventDefault();
      this.goPrev();
    });

    this.$root.on('click', '[data-action="save-and-close"]', e => {
      e.preventDefault();
      this.saveAndClose();
    });

    // Segment selection (objective step)
    this.$root.on('click', '[data-segment]', e => {
      e.preventDefault();
      const segment = $(e.currentTarget).attr('data-segment');
      this.answers.segment = segment;

      this.$root.find('[data-segment]').removeClass('selected');
      $(e.currentTarget).addClass('selected');
      this.updateNextButton('objective');
    });

    // Education level (special handling for conditionals)
    this.$root.on(
      'click',
      '[data-step="education"] [data-select-field="educationLevel"]',
      e => {
        e.preventDefault();
        e.stopPropagation();
        const $chip = $(e.currentTarget);
        const value = $chip.attr('data-select-value');

        $chip
          .closest('.wizard-chips')
          .find('[data-select-field="educationLevel"]')
          .removeClass('selected');
        $chip.addClass('selected');
        this.handleEducationLevelChange(value);
      }
    );

    // OAB phase (special handling for conditional subject section)
    this.$root.on(
      'click',
      '[data-step="oab-phase"] [data-select-field="barExamPhase"]',
      e => {
        e.preventDefault();
        e.stopPropagation();
        const $card = $(e.currentTarget);
        const value = $card.attr('data-select-value');

        $card
          .closest('.wizard-grid')
          .find('[data-select-field="barExamPhase"]')
          .removeClass('selected');
        $card.addClass('selected');
        this.handleOabPhaseChange(value);
      }
    );

    // Career multi-select with "outro" exclusivity
    this.$root.on('click', '[data-career-value]', e => {
      e.preventDefault();
      const $card = $(e.currentTarget);
      const value = $card.attr('data-career-value');
      this.handleCareerToggle($card, value);
    });

    // Single-select cards (generic)
    this.$root.on('click', '[data-select-field]', e => {
      e.preventDefault();
      const $card = $(e.currentTarget);
      const field = $card.attr('data-select-field');
      const value = $card.attr('data-select-value');

      if (field === 'educationLevel' || field === 'barExamPhase') {
        return;
      }

      this.answers[field] = value;
      $card
        .closest('.wizard-grid, .wizard-chips')
        .find(`[data-select-field="${field}"]`)
        .removeClass('selected');
      $card.addClass('selected');
      this.updateNextButton(this.getCurrentStepId());

      if (field === 'dailyHours' || field === 'studyWeekdays') {
        this.updateWeeklySummary();
      }
    });

    // Multi-select chips (generic)
    this.$root.on('click', '[data-multi-field]', e => {
      e.preventDefault();
      const $chip = $(e.currentTarget);
      const field = $chip.attr('data-multi-field');
      const value = $chip.attr('data-multi-value');

      const arr = this.answers[field];
      const idx = arr.indexOf(value);

      if (idx >= 0) {
        arr.splice(idx, 1);
        $chip.removeClass('selected');
      } else {
        arr.push(value);
        $chip.addClass('selected');
      }

      this.updateNextButton(this.getCurrentStepId());

      if (field === 'studyWeekdays') {
        this.updateWeeklySummary();
      }
    });

    // Select inputs (location state)
    this.$root.on('change', '[data-input-field]', e => {
      const field = $(e.target).attr('data-input-field');
      this.answers[field] = e.target.value || null;
      this.updateNextButton(this.getCurrentStepId());
    });

    // Course search
    this.$root.on('input', '#course-search-input', e => {
      this.handleCourseSearch(e.target.value);
    });

    // Category filter
    this.$root.on('click', '[data-category]', e => {
      e.preventDefault();
      const category = $(e.currentTarget).attr('data-category');
      this.activeCategory = category;

      this.$root.find('[data-category]').removeClass('active');
      $(e.currentTarget).addClass('active');

      const query = ($('#course-search-input').val() || '').trim();
      this.fetchCourses(query || undefined, category);
    });

    // Course selection
    this.$root.on('click', '[data-course-id]', e => {
      e.preventDefault();
      const id = parseInt($(e.currentTarget).attr('data-course-id'), 10);
      this.answers.selectedCourse = id;

      this.$root.find('[data-course-id]').removeClass('selected');
      $(e.currentTarget).addClass('selected');
    });

    // OAB SSO redirect
    this.$root.on('click', '[data-action="oab-sso-redirect"]', async e => {
      e.preventDefault();
      window.UserTracker?.emit('event', {
        eventName: 'account setup completed',
        data: {
          segment: 'OAB',
          setup_version: 'setup_v2',
          'first action chosen': 'Estude gratuitamente para OAB'
        }
      });

      try {
        const publicApiUrl = gon?.public_api_url || '';
        const response = await fetch(`${publicApiUrl}/sso/janus-oab`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': this.getCsrfToken()
          }
        });

        if (response.ok) {
          const data = await response.json();
          window.location.href =
            data.redirect_url || 'https://oab.damasio.com.br/';
        } else {
          window.location.href = 'https://oab.damasio.com.br/';
        }
      } catch {
        window.location.href = 'https://oab.damasio.com.br/';
      }
    });

    // OAB continue navigating
    this.$root.on('click', '[data-action="oab-continue"]', e => {
      e.preventDefault();
      window.UserTracker?.emit('event', {
        eventName: 'account setup completed',
        data: {
          segment: 'OAB',
          setup_version: 'setup_v2',
          'first action chosen': 'Continue navegando'
        }
      });
      this.goNext();
    });

    // Resend email
    this.$root.on('click', '[data-action="resend-email"]', async e => {
      e.preventDefault();
      const $btn = $(e.currentTarget);
      $btn.prop('disabled', true).text('Enviando...');

      try {
        await fetch('/api/user/resend_confirmation', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': this.getCsrfToken()
          }
        });
        $btn.text('E-mail reenviado!');
      } catch {
        $btn.text('Erro ao enviar. Tente novamente.').prop('disabled', false);
      }
    });

    // Objective next with tracking
    this.$root.on(
      'click',
      '[data-step="objective"] [data-action="next"]',
      () => {
        if (this.answers.segment) {
          window.UserTracker?.emit('event', {
            eventName: 'account setup preferences setted',
            data: {
              segment: SEGMENT_PRODUCT_LABEL[this.answers.segment],
              setup_version: 'setup_v2'
            }
          });
        }
      }
    );
  }

  getCsrfToken() {
    return (
      document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content') || ''
    );
  }

  // Course search
  handleCourseSearch(value) {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }

    this.searchDebounceTimer = setTimeout(() => {
      this.fetchCourses(value.trim() || undefined, this.activeCategory);
    }, SEARCH_DEBOUNCE_MS);
  }

  loadCourses() {
    this.activeCategory = 'Todos';
    this.$root.find('[data-category]').removeClass('active');
    this.$root.find('[data-category="Todos"]').addClass('active');
    $('#course-search-input').val('');
    this.fetchCourses();
  }

  async fetchCourses(search, category) {
    const $list = this.$root.find('.wizard-course-list');
    const $spinner = this.$root.find('#course-search-spinner');

    $spinner.show();
    $list.html(
      '<div class="wizard-loading"><div class="spinner" style="width:24px;height:24px;border:2px solid #ff5a1f;border-top-color:transparent;border-radius:50%;animation:spin 0.6s linear infinite"></div></div>'
    );

    try {
      const params = new URLSearchParams();

      if (search) {
        params.set('q', search);
      }
      if (this.answers.state && this.answers.acceptsOtherStates === 'nao') {
        params.set('state', this.answers.state);
      }
      params.set('per_page', '50');

      const response = await fetch(
        `/api/kratos/bord/study_guides/search?${params}`,
        {
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'X-CSRF-Token': this.getCsrfToken()
          }
        }
      );

      const data = await response.json();
      let guides = data.study_guides || [];

      if (category && category !== 'Todos') {
        const keywords = CATEGORY_KEYWORDS[category] || [];
        guides = guides.filter(g => {
          const text =
            `${g.title || ''} ${g.institute_name || ''} ${g.opportunity_job_name || ''}`.toLowerCase();
          return keywords.some(kw => text.includes(kw.toLowerCase()));
        });
      }

      this.renderCourses(guides);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[SetupWizard] Erro ao buscar cursos:', err);
      $list.html(
        '<div class="wizard-empty-state">Erro ao buscar cursos. Verifique se o Elasticsearch está ativo.</div>'
      );
    } finally {
      $spinner.hide();
    }
  }

  renderCourses(guides) {
    const $list = this.$root.find('.wizard-course-list');

    if (!guides.length) {
      $list.html(
        '<div class="wizard-empty-state">Nenhum curso encontrado.</div>'
      );
      return;
    }

    const html = guides
      .map(g => {
        const initials = (g.institute_initials || '').slice(0, 3);
        const jobName =
          g.opportunity_job_alias || g.opportunity_job_name || g.title || '';
        const instituteName = g.institute_name || '';
        const selected = this.answers.selectedCourse === g.id ? 'selected' : '';

        return `
        <button type="button" class="wizard-course-card ${selected}" data-course-id="${g.id}">
          <div class="wizard-course-card__initials">${initials}</div>
          <div class="wizard-course-card__info">
            <span class="wizard-course-card__title">${jobName}</span>
            <span class="wizard-course-card__subtitle">${instituteName}</span>
          </div>
        </button>
      `;
      })
      .join('');

    $list.html(html);
  }

  // Save and redirect
  async saveAndClose() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    const $btn = this.$root.find('[data-action="save-and-close"]');
    $btn.prop('disabled', true).text('Salvando...');

    try {
      const segment = this.answers.segment;
      const productId = segment ? SEGMENT_PRODUCT_MAP[segment] : 1;

      await Thor.UserPreference.update(
        {},
        {
          data: {
            user_preferences: {
              chose_product: true,
              preferred_product_id: productId,
              study_profile_attributes: {
                education_level: this.answers.educationLevel,
                degree: this.answers.degree,
                graduation_year: this.answers.graduationYear,
                careers:
                  this.answers.careers.length > 0
                    ? this.answers.careers.join(',')
                    : null,
                has_open_notice: this.answers.hasOpenNotice,
                dedication_time: this.answers.dedicationTime,
                state: this.answers.state,
                accepts_other_states: this.answers.acceptsOtherStates,
                bar_exam_phase: this.answers.barExamPhase,
                bar_exam_subject: this.answers.barExamSubject,
                bar_exam_experience: this.answers.barExamExperience,
                enem_subjects:
                  this.answers.enemSubjects.length > 0
                    ? this.answers.enemSubjects.join(',')
                    : null,
                target_score: this.answers.targetScore,
                desired_course: this.answers.desiredCourse,
                target_university: this.answers.targetUniversity,
                military_exam: this.answers.militaryExam,
                military_experience: this.answers.militaryExperience,
                study_weekdays:
                  this.answers.studyWeekdays.length > 0
                    ? this.answers.studyWeekdays.join(',')
                    : null,
                daily_hours: this.answers.dailyHours,
                current_level: this.answers.currentLevel
              }
            }
          }
        }
      );

      const segmentLabel = segment ? SEGMENT_PRODUCT_LABEL[segment] : undefined;
      const destination = this.answers.selectedCourse
        ? 'guia-de-estudos'
        : 'dashboard';

      window.UserTracker?.emit('event', {
        eventName: 'account setup completed',
        data: {
          segment: segmentLabel,
          request_path: window.location.pathname,
          setup_version: 'setup_v2',
          'first action chosen': destination,
          education_level: this.answers.educationLevel,
          degree: this.answers.degree,
          graduation_year: this.answers.graduationYear,
          careers:
            this.answers.careers.length > 0
              ? this.answers.careers.join(',')
              : undefined,
          has_open_notice: this.answers.hasOpenNotice,
          dedication_time: this.answers.dedicationTime,
          state: this.answers.state,
          accepts_other_states: this.answers.acceptsOtherStates,
          bar_exam_phase: this.answers.barExamPhase,
          bar_exam_subject: this.answers.barExamSubject,
          bar_exam_experience: this.answers.barExamExperience,
          enem_subjects:
            this.answers.enemSubjects.length > 0
              ? this.answers.enemSubjects.join(',')
              : undefined,
          target_score: this.answers.targetScore,
          desired_course: this.answers.desiredCourse,
          target_university: this.answers.targetUniversity,
          military_exam: this.answers.militaryExam,
          military_experience: this.answers.militaryExperience,
          study_weekdays:
            this.answers.studyWeekdays.length > 0
              ? this.answers.studyWeekdays.join(',')
              : undefined,
          daily_hours: this.answers.dailyHours,
          current_level: this.answers.currentLevel,
          selected_course: this.answers.selectedCourse
        }
      });

      await new Promise(resolve => setTimeout(resolve, 100));

      if (this.answers.selectedCourse) {
        try {
          await Thor.StudyGuides.favorite(
            {},
            {
              data: { study_guide_id: this.answers.selectedCourse }
            }
          );
        } catch {
          /* ignore */
        }

        window.location.href = `https://${this.bordDomain}/b/guia-de-estudos/${this.answers.selectedCourse}/sobre`;
      } else {
        window.location.href = `https://${this.bordDomain}/b/dashboard`;
      }
    } catch {
      this.isSaving = false;
      $btn.prop('disabled', false).text('Ir para a plataforma');
      toastr.error(
        'Ocorreu um erro ao salvar suas preferências. Tente novamente.'
      );
    }
  }
}

(() => {
  document.addEventListener('turbolinks:load', () => {
    new SetupWizard();
  });
})();
